let AUTH_CLIENT_ID = '10542';
let AUTH_REDIRECT_URL = 'https://api.supply.sobrus.ovh/auth/token';
let AUTH_DOMAIN = 'https://account.sobrus.ovh';
let API_URL = 'https://api.supply.sobrus.ovh/';
let IMGS_PATH = 'https://api.supply.sobrus.ovh/uploads/images/';
let ACCOUNT_LINK = 'https://account.sobrus.ovh';
let BASE_URL = 'https://api.supply.sobrus.ovh';
let PRODUCT_IMG_PATH = 'https://ma.pharma.sobrus.com/uploads/ma/products/watermarked/';
let IMAGE_PATH = 'https://api.marketplace.sobrus.ovh/uploaded_files/offers/images/';
let CDN_URL = 'https://cdn.sobrus.ovh/';

if (import.meta.env.VITE_ENV === 'production') {
	AUTH_CLIENT_ID = '10855';
	AUTH_REDIRECT_URL = 'https://api.supply.sobrus.com/auth/token';
	AUTH_DOMAIN = 'https://account.sobrus.com';
	API_URL = 'https://api.supply.sobrus.com/';
	IMGS_PATH = 'https://api.supply.sobrus.com/uploads/images/';
	IMAGE_PATH = 'https://api.marketplace.sobrus.com/uploaded_files/offers/images/';
	ACCOUNT_LINK = 'https://account.sobrus.com';
	PRODUCT_IMG_PATH = 'https://ma.pharma.sobrus.com/uploads/ma/products/watermarked/';
	BASE_URL = 'https://api.supply.sobrus.com';
	CDN_URL = 'https://sobruscdn.com/';
}

const AUTH_URL = `${AUTH_DOMAIN}/authorize?response_type=code&client_id=${AUTH_CLIENT_ID}&scope=openid%20offline_access%20profile%20email&redirect_uri=${AUTH_REDIRECT_URL}&prompt=login`;

export { API_URL, IMGS_PATH, AUTH_URL, ACCOUNT_LINK, BASE_URL, PRODUCT_IMG_PATH, IMAGE_PATH, CDN_URL };
